export default __webpack_public_path__ + "static/media/ptm.a325a7c1.svg";